import CONSTANTS from '../constants'
import { deleteRequest, getRequest, postRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'

// Calls the API to get Facility Initials
export const getPassList = (page = '') => (dispatch) => {
    let query = `${page ? '?page=' + page : ''}`
    dispatch({ type: CONSTANTS.GET_PASS_LIST_REQUEST })
    return getRequest(APICONFIG.getPassListUrl + query).then((res) => {
        dispatch({ type: CONSTANTS.GET_PASS_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch(() => {
        dispatch({ type: CONSTANTS.GET_PASS_LIST_FAILURE })
    })
}

// GET VEHICLE LIST DETAILS
export const getVehicleDataList = () => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_REQUEST })
    return getRequest(`${APICONFIG.getVehicleListUrl}/page/1`).then((res) => {
        dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch(() => {
        dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_FAILURE })
    })
}

// Post Vehicle Details
export const postVehicleList = (data) => (dispatch) => {
    dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_REQUEST })
    return postRequest(APICONFIG.postVehicleListUrl, data).then((res) => {
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch(() => {
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_FAILURE })
    })
}

// Delete Vehicle Details

export const DeleteVehicleList = (id) => (dispatch) => {
    dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_REQUEST })
    return deleteRequest(`${APICONFIG.deleteVehicleItemUrl}/${id}`).then((res) => {
        dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_SUCCESS })
        return res.data
    }).catch(() => {
        dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_FAILURE })
    })
}


// GET VEHICLE LIST DETAILS
export const getPassListDetail = (id) => (dispatch) => {
    dispatch({ type: CONSTANTS.FACILITY_PASS_LIST_REQUEST })
    return getRequest(`${APICONFIG.getFacilityPass}/${id}`).then((res) => {
        dispatch({ type: CONSTANTS.FACILITY_PASS_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch(() => {
        dispatch({ type: CONSTANTS.FACILITY_PASS_LIST_FAILED })
    })
}

export const downloadPass = (account_number = '', appleWalletApi = '') => async (dispatch) => {
    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_REQUEST })

    // API URL with query parameter
    const apiUrl = `${appleWalletApi}?account_number=${account_number}`

    try {
        const response = await fetch(apiUrl)
        const contentType = response.headers.get('content-type')

        if (contentType && contentType.includes('application/json')) {
            const errorData = await response.json()
            dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE, payload: errorData })
            return Promise.reject(errorData) // Ensure error data is passed to `.catch()`
        }

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = url
        a.download = `pass-${account_number}.pkpass`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)

        dispatch({ type: CONSTANTS.PASS_DOWNLOAD_SUCCESS })
        return Promise.resolve()
    } catch (err) {
        dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE, payload: err })
        return Promise.reject(err)
    }
}

export const downloadGooglePass = (account_number = '', googleWalletApi = '') => (dispatch) => {
    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_REQUEST })
    // API URL with query parameter
    const apiUrl = `${googleWalletApi}?account_number=${account_number}`

    return getRequest(apiUrl).then((res) => {
        dispatch({ type: CONSTANTS.PASS_DOWNLOAD_SUCCESS, data: res })

        // Handle the URL response
        // Option 1: Open the URL in a new tab
        window.open(res, '_blank')

        // Option 2: Create a temporary link and trigger click
        const a = document.createElement('a')
        a.href = res
        a.target = '_blank' // Open in new tab
        document.body.appendChild(a)
        a.click()
        a.remove()
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE })
        return err
    })
}